import { formatCurrency, formatDate, formatGender, formatSmoker, getCountryName, getFrecuencyLabel } from "../../../../../utils/utils";
import { ConfirmationData, LastQuote, QuoteSelected, updateMapWithFields2 } from "../../../../common/summary-common/confirmationData";

export const defaultCoverageInformation: Map<string, ConfirmationData> = new Map([
    ["gender", { label: "Género", fontWeight: "bold", showBorder: true }],
    ["smoker", { label: "Estado de fumador", fontWeight: "bold", showBorder: true }],
    ["country", { label: "País", fontWeight: "bold", showBorder: true }],
    ["dob", { label: "Fecha de nacimiento", fontWeight: "bold", showBorder: true }],
    ["annual_income", { label: "Ingreso anual", fontWeight: "bold", showBorder: true }],
    ["product_type", { label: "Plan", fontWeight: "bold", showBorder: true }],
    ["term_selected", { label: "Término", fontWeight: "bold", showBorder: true }],
    ["total_premium", { label: "Prima a pagar", fontWeight: "bold", showBorder: true }],
    ["frecuency", { label: "Frecuencia de pago", fontWeight: "bold", showBorder: true }],
    ["Cobertura principal", { label: "Cobertura principal", fontWeight: "bold", coverageLabel: "Cobertura principal", value: "Valor Asegurado" }],

    ["policy_amount", { label: "Beneficio por muerte", showBorder: true, fontWeight: "bold" }],
    ["Beneficios en vida", { label: "Beneficios en vida", fontWeight: "bold", coverageLabel: "Beneficios en vida", value: "Valor Asegurado" }],
    ["protection_amount", { label: "Pago anticipado por enfermedad terminal", showBorder: true, fontWeight: "bold" }],
    ["add_amount", { label: "Pago anticipado por incapacidad o muerte accidental", showBorder: true, fontWeight: "bold", hiddenIfEmpty: true }],
    ["rop_amount", { label: "Retorno de Prima", showBorder: true, fontWeight: "bold", hiddenIfEmpty: true }],
    ["permanent_disability", { label: "Protección de ingreso por incapacidad total permanente", showBorder: true, fontWeight: "bold", hiddenIfEmpty: true }],
    ["temporary_total_disability", { label: "Protección de ingreso por incapacidad total temporal", showBorder: true, fontWeight: "bold", hiddenIfEmpty: true }],

]);

export const updateCoverageInformation = (selected: QuoteSelected, lastQuote: LastQuote, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    const formatAmount = (amount: number | undefined): string =>
        amount !== undefined ? formatCurrency(amount) : "";
    console.log("selected", selected)
    console.log("lastQuote", lastQuote)
    const baseFields: Array<[string, string | null]> = [
        ["gender", formatGender(selected?.gender || "", "es")],
        ["smoker", formatSmoker(selected?.smoker, "es")],
        ["country", getCountryName(selected?.country || "")],
        ["dob", formatDate(selected?.lead?.date_of_birth || "", "es")],
        ["annual_income", formatAmount(selected?.annual_income)],
        ["product_type", selected?.product_type ? (selected.product_type === "easy_term" ? "Easy Term" : "Master Term") : ""],
        ["term_selected", selected?.term_selected ? `${selected.term_selected} años` : null],
        ["total_premium", formatAmount(lastQuote?.total_premium_in_frecuency)],
        ["frecuency", selected?.frecuency_selected ? getFrecuencyLabel(selected.frecuency_selected) : ""],
        ["policy_amount", formatAmount(selected?.policy_amount)],
        ["protection_amount", (() => {
            const policyAmount = selected?.policy_amount || 0;
            if (policyAmount >= 1000000) {
                return formatAmount(500000);
            } else {
                return formatAmount(Math.min(policyAmount / 2, 250000));
            }
        })()],
    ];

    if (lastQuote?.income_replacement?.temporary_total_disability > 0) {
        baseFields.push(["temporary_total_disability", `Hasta ${formatAmount(lastQuote.income_replacement.temporary_total_disability)} por mes`]);
    }

    if (lastQuote?.income_replacement?.permanent_disability > 0) {
        baseFields.push(["permanent_disability", formatAmount(lastQuote.income_replacement.permanent_disability)]);
    }

    if (selected?.add_amount) {
        baseFields.push(["add_amount", formatAmount(selected?.add_amount)]);
    }


    if (lastQuote?.rop_amount && selected?.rop) {
        baseFields.push(["rop_amount", formatAmount(lastQuote?.rop_amount) + " (Monto de retorno)"]);
    }

    return updateMapWithFields2(baseFields, cd, false);
};